import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useApp } from "../context/AppContext";
import { ArrowRight } from "lucide-react";

export default function Orders() {
  const { customer } = useApp();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!customer) return;
    api.get("/orders", { params: { customer_id: customer.id } }).then(r => setOrders(r.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer]);

  if (!customer) return <div className="p-20 text-center text-[#8A8A8A]">Please sign in.</div>;

  return (
    <div className="max-w-screen-2xl mx-auto px-6 md:px-12 py-16" data-testid="orders-page">
      <p className="label-eyebrow">Your history</p>
      <h1 className="font-editorial text-5xl sm:text-6xl tracking-editorial mt-3 mb-12">Orders</h1>

      {orders.length === 0 && <p className="text-[#8A8A8A]">No orders yet.</p>}

      <div className="divide-y divide-[#1A1A1A]/10">
        {orders.map(o => (
          <Link to={`/orders/${o.id}`} key={o.id} className="py-6 grid grid-cols-12 gap-4 items-center hover:bg-[#F0EFEA]/50 transition-colors px-4" data-testid={`order-${o.order_no}`}>
            <div className="col-span-6">
              <p className="label-eyebrow">{o.order_no} · {new Date(o.created_at).toLocaleDateString()}</p>
              <p className="font-editorial text-2xl mt-1">{o.items.length} products · {o.items.reduce((a, b) => a + b.quantity_boxes, 0)} boxes</p>
            </div>
            <div className="col-span-3">
              <p className="text-xs uppercase tracking-[0.2em] text-[#1E2C5A]">{o.dispatch_status.replace(/_/g, " ")}</p>
              <p className="text-xs text-[#8A8A8A] mt-1">Payment: {o.payment_status}</p>
            </div>
            <div className="col-span-3 text-right">
              <p className="font-editorial text-2xl">₹{o.total.toFixed(0)}</p>
              <ArrowRight className="w-4 h-4 inline text-[#8A8A8A] ml-1" strokeWidth={1.5} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
